import { css } from 'lit';

export const style = css`
  [hidden],
  .hidden {
    display: none;
  }

  .read-only {
    margin-bottom: -1em;
  }
`;
